// extracted by mini-css-extract-plugin
module.exports = {"code":"ReactParser_code__jV9XD"};